import { graphql, useStaticQuery } from 'gatsby'
import { mapEdgesToNodes } from '../lib/helpers'
import BlogPostPreviewShort from './blog-post-preview-short'
import { IPostNode } from '../types/postsListing'

import { similarDiv, similarTitle } from './blog-post-preview.module.css'

interface Props {
  articles: IPostNode[]
}

function SimilarArticlesComponent({ articles }: Props) {
  return (
    <div className={similarDiv}>
      <h3 className={`${similarTitle} font-bold`}>Latest Posts:</h3>
      <BlogPostPreviewShort nodes={articles} />
    </div>
  )
}

const query = graphql`
  query SimilarArticles {
    posts: allSanityPost(
      sort: { publishedAt: DESC }
      filter: { slug: { current: { ne: null } }, publishedAt: { ne: null } }
      limit: 3
    ) {
      edges {
        node {
          id
          publishedAt
          mainImage {
            ...SanityImage
            alt
          }
          title
          excerpt
          slug {
            current
          }
          categories {
            id
            title
            slug {
              current
            }
          }
        }
      }
    }
  }
`

export default function SimilarArticles() {
  const data = useStaticQuery<Queries.SimilarArticlesQuery>(query)

  const postNodes = mapEdgesToNodes(data.posts)
  return <SimilarArticlesComponent articles={postNodes} />
}
